import React, { useEffect, useState } from "react";
import TarifBlock from "../../common/TarifBlock";
import { useFormikContext, Formik, Form, Field } from "formik";
import { useData } from "../../utils/dataProvider";

export default function Tarif({ data }) {
  const { values, setFieldValue } = useFormikContext();
  const { setPage, doMoney, doSpMoney } = useData();
  const [filter, setFilter] = useState([]);
  const [modal, setModal] = useState(false);

  const filterTarif = (item) => {
    if (
      values.vermietung == item.vermietung &&
      values.zahlungsweise == item.zahlungsweise &&
      (values.gewerbe == item.gewerbe || values.privat == item.privat)
    ) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    setFieldValue("tarif", null);
  }, []);

  useEffect(() => {
    if (values.private !== null && values.zahlungsweise !== null) {
      var filtered = data
        .filter(filterTarif)
        .sort((a, b) => a.praemie - b.praemie);

      setFilter(filtered);
    }
  }, [values]);
  function checkPossible(field, value) {
    if (data.findIndex((tarifitem) => tarifitem[field] === value) > -1)
      return true;
    return false;
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      {modal && !values.vermietung ? (
        <div className="modal-box">
          <div className="modal">
            <div className="modal-headline">
              Wollen Sie zusätzlich eine Fahrzeug-Rechtsschutzversicherung für
              49,- € im Jahr abschliessen?
            </div>
            <div className="button-group">
              <div
                onClick={() => {
                  setPage(3);
                }}
                style={{ cursor: "pointer" }}
              >
                Nein,danke.
              </div>
              <div
                className="btn"
                style={{ marginTop: 0, marginLeft: 16 }}
                onClick={() => {
                  setFieldValue("legalProtection", 1);
                  setPage(3);
                }}
              >
                Ja, gerne.
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="formular">
        <div className="formular-headline">
          Bitte helfen Sie uns, den richtigen Tarif zu finden:
        </div>
        <div className="line-one-input">
          <div className="ec-label">Wie nutzen Sie das Fahrzeug?</div>
          <div className="select">
            <div
              onClick={() => {
                setFieldValue("privat", true);
                setFieldValue("gewerbe", null);
                setFieldValue("vermietung", null);
                setFieldValue("tarif", null);
                setFieldValue("vorsteuer", false);
                setFieldValue("customerType", "Privatperson");
              }}
              className={`select-block ${values.privat ? "aktiv" : ""}`}
            >
              <div className="select-name">Private Nutzung</div>
              <div className="choose "></div>
            </div>
            <div
              onClick={() => {
                setFieldValue("privat", null);
                setFieldValue("gewerbe", true);
                setFieldValue("tarif", null);
                setFieldValue("vorsteuer", true);
                setFieldValue("customerType", "Firma");
              }}
              className={`select-block ${!values.privat ? "aktiv" : ""}`}
            >
              <div className="select-name">Gewerbliche Nutzung</div>
              <div className="choose "></div>
            </div>
          </div>
        </div>
        {!values.privat && checkPossible("vermietung", true) && (
          <div className="line-one-input">
            <div className="ec-label">Möchten Sie das Fahrzeug vermieten?</div>
            <div className="select">
              <div
                onClick={() => {
                  setFieldValue("vermietung", null);
                  setFieldValue("tarif", null);
                }}
                className={`select-block ${!values.vermietung ? "aktiv" : ""}`}
              >
                <div className="select-name">
                  Zulassung ohne besondere Verwendung
                </div>
                <div className="choose "></div>
              </div>
              <div
                onClick={() => {
                  setFieldValue("vermietung", true);
                  setFieldValue("tarif", null);
                }}
                className={`select-block ${values.vermietung ? "aktiv" : ""}`}
              >
                <div className="select-name">
                  Zulassung als Selbstfahrer-Vermietfahrzeug
                </div>
                <div className="choose "></div>
              </div>
            </div>
          </div>
        )}
        <div className="line-one-input">
          <div className="ec-label">Wie möchten Sie bezahlen?</div>
          <div className="select">
            <div
              onClick={() => {
                setFieldValue("zahlungsweise", "lastschrift");
                setFieldValue("tarif", null);
              }}
              className={`select-block ${
                values.zahlungsweise == "lastschrift" ? "aktiv" : ""
              }`}
            >
              <div className="select-name">Lastschrift</div>
              <div className="choose "></div>
            </div>
            {checkPossible("zahlungsweise", "ueberweisung") && (
              <div
                onClick={() => {
                  setFieldValue("zahlungsweise", "ueberweisung");
                  setFieldValue("tarif", null);
                }}
                className={`select-block ${
                  values.zahlungsweise == "ueberweisung" ? "aktiv" : ""
                }`}
              >
                <div className="select-name">Überweisung</div>
                <div className="choose "></div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="formular" style={{ marginTop: 24 }}>
        <div className="formular-headline">
          {filter.length > 0
            ? "Wählen Sie Ihren Tarif:"
            : "Zu Ihrer Auswahl gibt es keinen Tarif."}
        </div>
        <div className="line-one-input">
          <div className="select-long">
            {filter.length > 0
              ? filter.map((singleTarif, idx) => {
                  return (
                    <TarifBlock
                      key={singleTarif.ID}
                      values={values}
                      setFieldValue={setFieldValue}
                      data={singleTarif}
                    />
                  );
                })
              : null}
          </div>
        </div>
      </div>
      {values.tarif ? (
        !values.vermietung ? (
          <div className="btn" onClick={() => setModal(true)}>
            Weiter zu Ihren Daten
          </div>
        ) : (
          <div className="btn" onClick={() => setPage(3)}>
            Weiter zu Ihren Daten
          </div>
        )
      ) : (
        <div className="btn" style={{ opacity: 0.5 }}>
          Weiter zu Ihren Daten
        </div>
      )}
    </div>
  );
}
